import {
  CREATE_SEARCH,
} from 'actions/actionConstants'
import { createAppReducer } from 'lib/redux/reducerUtils'

export const initialSearchState: App.SearchState = {
  searches: {},
}

export default createAppReducer<App.SearchState>(initialSearchState, {
  [CREATE_SEARCH]: (state, action) => {
    const { key, searchId, searchContext, searchEvent } = action

    return {
      searches: {
        ...state.searches,
        [key]: {
          searchId,
          searchContext: searchContext ?? state.searches[key]?.searchContext,
          searchEvent,
        },
      },
    }
  },
})
